import { useMutation, useQuery, UseQueryResult } from "react-query";
import Api, { IApi } from "../../services/Api";
import { Message, MessageIn } from "../../services/Api/swagger";
import { getApiEndpoint } from "../../services/Config";

export const usePostMessage = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<number, any, MessageIn>(
    // @ts-ignore
    (params: MessageIn) => (api && api.postMessages(params)) || undefined
  );
};

export const useGetMessages = (): UseQueryResult<Message[]> => {
  const api: IApi = Api.create(getApiEndpoint());

  return useQuery<Message[]>(
    "messages",
    // @ts-ignore
    () => api && api.getMessages()
  );
};

export const usePutMessage = () => {
  const api: IApi = Api.create(getApiEndpoint());
  return useMutation<Message, any, { id: number; messageToPut: Message }>(
    //@ts-ignore
    (params: { id: number; messageToPut: Message }) =>
      api && api.putMessage(params.id, params.messageToPut)
  );
};

export const useGetMessageById = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<Message, any, number>(
    // @ts-ignore
    (params: number) => (api && api.getMessageById(params)) || undefined
  );
};

export const useDeleteMessageById = () => {
  const api: IApi = Api.create(getApiEndpoint());

  return useMutation<number, any, number>(
    // @ts-ignore
    (params: number) => api && api.deleteMessageById(params)
  );
};

export const useGetMessagesActifs = (): UseQueryResult<Message[]> => {
  const api: IApi = Api.create(getApiEndpoint());
  return useQuery<Message[]>(
    "active-messages",
    // @ts-ignore
    () => api && api.getActiveMessages()
  );
};
